<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const authStore = useAuthStore()
    const searchWizardStore = useSearchWizardStore()
    // setup to fetch currencies ASAP
    return {
      authStore,
      searchWizardStore,
    }
  },
})
class BasicLayout extends Vue {}

export default toNative(BasicLayout)
</script>
